<ng-template #tableTemplate>
    <n-data-table id="delete-client-nfs-share-table"
        style="height: 2rem;"
        [columnDefs]="tableColumnDefs"
        [data]="dataList">
    </n-data-table>
</ng-template>

